import React from "react";
import Button from "../../atoms/Button";
import { ReactComponent as Logo } from "../../svgs/logo.svg";
import SignupWall from "../../organisms/SignupWall";
import { Link } from "react-router-dom";
import PasswordRecoveryForm from "../../organisms/PasswordRecoveryForm";

const PasswordRecovery = ({ portal }) => {
  const textColor = {
    seller: "text-white",
    buyer: "text-black",
    trader: "text-black",
  };
  return (
    <div className="flex">
      <div className="shrink-0 grow-0 basis-[50%] flex flex-col items-center pl-32 py-11">
        <Logo />
        <h2 className="text-4xl mt-6">Password Recovery</h2>
        <p className="text-sm text-gray-500 mt-4">Fill the required details</p>

        <PasswordRecoveryForm userType = {portal}/>
      </div>
      <div className="shrink-0 grow-0 basis-[50%] pl-32 h-auto relative">
        <SignupWall portal={portal}>
          <p
            className={`${textColor[portal]} text-center text-lg leading-10 mb-4`}
          >
            Already have a account
          </p>
          <Link to={`/${portal}`}>
            <Button
              color="white"
              varient="rounded"
              className="w-fit py-2 px-8 mx-auto text-2xl font-medium tracking-widest"
            >
              Log in account
            </Button>
          </Link>
        </SignupWall>
      </div>
    </div>
  );
};

export default PasswordRecovery;
